module.exports = __webpack_public_path__ + "static/media/ceo.209553a9.jpg";